import { useState } from 'react';
import toast from 'react-hot-toast';

import { IconCheckCircle, IconClose } from '../../../common/icons';
import { useModalDialog } from '../../../common/hooks/use-modal-dialog';
import { CalfSearch } from './pickers';
import { useReconcileSale } from '../contexts/sales';

import '../styles/sales.css';

// Reconciliar una reserva de cruce (project_pending) con la cría real cuando nace
// (PATCH /:id/reconcile). La cría debe ser hija de la donadora del cruce (409 si no).
export default function ReconcileModal({ sale, onClose, onSaved }) {
    const { mutateAsync: reconcile, isPending } = useReconcileSale(sale.id);
    const cardRef = useModalDialog(onClose);
    const [calf, setCalf] = useState(null);

    const crossLabel = sale.projected_cross?.code || sale.projected_cross?.name || `#${sale.projected_cross?.id}`;
    const calfLabel = (c) => c?.name || c?.number || (c?.id ? `#${c.id}` : '—');

    const submit = async () => {
        if (!calf) { toast.error('Elegí la cría nacida'); return; }
        try {
            await reconcile(calf.id);
            toast.success('Reserva reconciliada');
            onSaved?.();
        } catch (er) {
            if (er?.status === 409) toast.error(er?.message || 'La cría debe ser hija de la donadora del cruce (o ya tiene comprador)');
            else if (er?.status === 404) toast.error(er?.message || 'Venta o cría no encontrada');
            else if (er?.status !== 403) toast.error(er?.message || 'No se pudo reconciliar');
        }
    };

    return (
        <div className="sale-modal" role="dialog" aria-modal="true" aria-label="Reconciliar reserva">
            <div className="sale-modal__overlay" onClick={onClose} aria-hidden="true" />
            <div className="sale-modal__card" ref={cardRef}>
                <header className="sale-modal__head">
                    <div>
                        <h2 className="sale-modal__title">Reconciliar reserva</h2>
                        <span className="sale-modal__sub">Cruce {crossLabel} · {sale.buyer?.name || `Cliente #${sale.buyer?.id}`}</span>
                    </div>
                    <button type="button" className="sale-modal__close" onClick={onClose} aria-label="Cerrar"><IconClose /></button>
                </header>

                <div className="sale-form">
                    <div className="sale-form__field">
                        <span className="sale-form__label">Cría nacida</span>
                        {calf ? (
                            <span className="sale-form__picked">
                                <IconCheckCircle /> {calfLabel(calf)}{calf.number ? ` · ${calf.number}` : ''}
                                <button type="button" className="sale-form__clear" onClick={() => setCalf(null)} disabled={isPending} aria-label="Cambiar cría">×</button>
                            </span>
                        ) : (
                            <CalfSearch onSelect={(a) => setCalf(a)} disabled={isPending} />
                        )}
                        <span className="sale-form__note">La cría debe ser hija de la donadora del cruce reservado.</span>
                    </div>
                </div>

                <footer className="sale-modal__foot">
                    <button type="button" className="sale-btn sale-btn--ghost" onClick={onClose} disabled={isPending}>Cancelar</button>
                    <button type="button" className="sale-btn sale-btn--primary" onClick={submit} disabled={isPending || !calf}>
                        {isPending ? 'Reconciliando…' : 'Reconciliar'}
                    </button>
                </footer>
            </div>
        </div>
    );
}
